import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";
import PageLayout from "@/components/feature/PageLayout";
import { NEWS } from "@/data/news";

export default function NoticePage() {
  const { t } = useTranslation();

  return (
    <PageLayout eyebrow="NOTICE" title={t("notice.title")} desc={t("notice.desc")}>
      <ul className="divide-y divide-background-200 border-y border-background-200">
        {NEWS.map((n) => (
          <li key={n.id}>
            <Link
              to={`/notice/${n.id}`}
              className="group flex flex-col md:flex-row md:items-center gap-3 md:gap-6 py-5 cursor-pointer"
            >
              <span className={`inline-flex w-fit px-2.5 py-1 rounded-md text-xs font-semibold ${n.catColor}`}>
                {t(n.catKey)}
              </span>
              <span className="flex-1 font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {t(n.titleKey)}
              </span>
              <span className="text-xs text-foreground-500 font-label">{n.date}</span>
            </Link>
          </li>
        ))}
      </ul>
    </PageLayout>
  );
}
